import React from 'react'
import { CreateBorrowFormContainer } from '../../containers/Officer/CreateBorrowFormContainer'
export const CreateBorrowFormPage = () => {
  return (
    <CreateBorrowFormContainer />
  )
}
